import { render } from "./AiAttributeFilterComponent.vue?vue&type=template&id=3d5c54d7&scoped=true"
import script from "./AiAttributeFilterComponent.vue?vue&type=script&lang=js"
export * from "./AiAttributeFilterComponent.vue?vue&type=script&lang=js"

import "./AiAttributeFilterComponent.vue?vue&type=style&index=0&id=3d5c54d7&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d5c54d7"]])

export default __exports__